import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/property-sample-image.jpg'
import _imports_1 from '../../../assets/icons/delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-7212297d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main_project_preview md:!tw-pb-16 md:!tw-box-border"
}
const _hoisted_2 = { class: "left_block" }
const _hoisted_3 = { class: "proj_components" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list_block" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Project Overview"),
  /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-8" })
], -1))
const _hoisted_5 = { class: "list_block" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Project Details", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-8" }, null, -1))
const _hoisted_8 = { class: "list_block__item" }
const _hoisted_9 = { class: "list_block__item__wrapper" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list_block__item__wrapper__left" }, "Project Type", -1))
const _hoisted_11 = { class: "list_block__item__wrapper__right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-8" }, null, -1))
const _hoisted_13 = { class: "list_block" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Estimate", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-8" }, null, -1))
const _hoisted_16 = { class: "list_block__item" }
const _hoisted_17 = { class: "list_block__item__wrapper" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list_block__item__wrapper__left" }, "Start Date", -1))
const _hoisted_19 = { class: "list_block__item__wrapper__right" }
const _hoisted_20 = { class: "list_block__item__wrapper" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list_block__item__wrapper__left" }, "Total Phase", -1))
const _hoisted_22 = { class: "list_block__item__wrapper__right" }
const _hoisted_23 = { class: "list_block__item__wrapper" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list_block__item__wrapper__left" }, "Total Tasks", -1))
const _hoisted_25 = { class: "list_block__item__wrapper__right" }
const _hoisted_26 = { class: "list_block__item__wrapper" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list_block__item__wrapper__left" }, "Duration", -1))
const _hoisted_28 = { class: "list_block__item__wrapper__right" }
const _hoisted_29 = { class: "list_block__item__wrapper" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list_block__item__wrapper__left" }, "Total Cost", -1))
const _hoisted_31 = { class: "list_block__item__wrapper__right" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-4" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-8" }, null, -1))
const _hoisted_34 = { class: "right_block" }
const _hoisted_35 = { class: "top_links_main desktop__wrapper" }
const _hoisted_36 = { class: "back_results" }
const _hoisted_37 = { class: "project_info__wrapper" }
const _hoisted_38 = { class: "card_content" }
const _hoisted_39 = { class: "card_content__header" }
const _hoisted_40 = { class: "card_content__title" }
const _hoisted_41 = { id: "project_name" }
const _hoisted_42 = { class: "card_content__title_info" }
const _hoisted_43 = {
  class: "raised",
  id: "project_review_item_icon_commerical"
}
const _hoisted_44 = ["src"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pointer_events_none" }, "Commercial", -1))
const _hoisted_46 = {
  class: "project_id",
  id: "project_id_container"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pointer_events_none" }, "Project ID:", -1))
const _hoisted_48 = { class: "pointer_events_none" }
const _hoisted_49 = { class: "card_content__footer" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Project Notes", -1))
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = { class: "title" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Project Title", -1))
const _hoisted_54 = { class: "description" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Project Notes", -1))
const _hoisted_56 = { class: "custom_editor" }
const _hoisted_57 = { class: "edit__buttons" }
const _hoisted_58 = { class: "specialism__wrapper" }
const _hoisted_59 = { class: "header" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Specialism")
], -1))
const _hoisted_61 = { class: "specialism__wrapper__content" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "specialism-card-list" }
const _hoisted_64 = { class: "specialism-card-list__item-author" }
const _hoisted_65 = { class: "speicalism__icon" }
const _hoisted_66 = ["src"]
const _hoisted_67 = ["src"]
const _hoisted_68 = { class: "specialism-card-list__item-author-content" }
const _hoisted_69 = { class: "category_icon" }
const _hoisted_70 = ["src"]
const _hoisted_71 = { class: "category_text" }
const _hoisted_72 = {
  key: 0,
  class: "edit-mode-button"
}
const _hoisted_73 = { class: "edit__buttons" }
const _hoisted_74 = { class: "client_info__wrapper" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Client", -1))
const _hoisted_76 = { class: "client__cardlist" }
const _hoisted_77 = { class: "card_header" }
const _hoisted_78 = { class: "client_img" }
const _hoisted_79 = ["src"]
const _hoisted_80 = { class: "client_info" }
const _hoisted_81 = { class: "header_bottom" }
const _hoisted_82 = { class: "card__info__tags__custom" }
const _hoisted_83 = ["src"]
const _hoisted_84 = {
  key: 0,
  class: "custom_tags__more"
}
const _hoisted_85 = {
  key: 1,
  class: "description"
}
const _hoisted_86 = { class: "client_card_description" }
const _hoisted_87 = { class: "properties_wrapper" }
const _hoisted_88 = { class: "header" }
const _hoisted_89 = { class: "title" }
const _hoisted_90 = { id: "project_properties_title" }
const _hoisted_91 = { class: "count__property pointer_events_none" }
const _hoisted_92 = { class: "properties_wrapper__content" }
const _hoisted_93 = { class: "properties_wrapper__left" }
const _hoisted_94 = { class: "properties_wrapper__info__left" }
const _hoisted_95 = { class: "location" }
const _hoisted_96 = { class: "prop_name" }
const _hoisted_97 = ["src"]
const _hoisted_98 = { class: "pointer_events_none" }
const _hoisted_99 = { class: "property__info" }
const _hoisted_100 = { class: "property__info__item" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "|", -1))
const _hoisted_102 = { class: "property__info__item" }
const _hoisted_103 = { class: "pointer_events_none" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "|", -1))
const _hoisted_105 = { class: "property__info__item" }
const _hoisted_106 = { class: "pointer_events_none" }
const _hoisted_107 = { class: "property_type" }
const _hoisted_108 = { class: "properties_wrapper__info__right" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "property_image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_110 = {
  key: 0,
  class: "prop_count"
}
const _hoisted_111 = { class: "properties_wrapper__right" }
const _hoisted_112 = {
  key: 0,
  class: "map__wrapper",
  id: "map_properties"
}
const _hoisted_113 = {
  key: 0,
  class: "edit-mode-button"
}
const _hoisted_114 = { class: "edit__buttons" }
const _hoisted_115 = {
  key: 0,
  class: "documents_attachment"
}
const _hoisted_116 = { class: "title" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { id: "project_documents_attachment_name" }, " Documents / Attachments ", -1))
const _hoisted_118 = ["src"]
const _hoisted_119 = {
  key: 0,
  class: "group__cards"
}
const _hoisted_120 = { class: "group__card__text" }
const _hoisted_121 = { class: "doc_main" }
const _hoisted_122 = ["onClick"]
const _hoisted_123 = { class: "tw-cursor-pointer" }
const _hoisted_124 = ["onClick"]
const _hoisted_125 = {
  key: 0,
  class: "property__images"
}
const _hoisted_126 = ["src", "onClick"]
const _hoisted_127 = {
  key: 1,
  class: "edit-mode-button"
}
const _hoisted_128 = { class: "edit__buttons" }
const _hoisted_129 = { class: "modal__content" }
const _hoisted_130 = { class: "left_upload_img" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Upload images and files.", -1))
const _hoisted_132 = { class: "upload__area" }
const _hoisted_133 = { class: "uploade-wrapper" }
const _hoisted_134 = {
  key: 0,
  class: "error_msg"
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload__text" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Drag and drop documents, or"),
    /*#__PURE__*/_createElementVNode("span", null, "Browse")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "" }, " Attachments such as images, design ideas and documents help better understand the project and provide increasingly accurate estimates. ")
], -1))
const _hoisted_136 = { class: "selected-info" }
const _hoisted_137 = { class: "image__upload__wrapper" }
const _hoisted_138 = { key: 0 }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Uploaded Files", -1))
const _hoisted_140 = { class: "uploaded_details_wrapper" }
const _hoisted_141 = { class: "prop_img_details" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_143 = { class: "upload__list" }
const _hoisted_144 = {
  key: 1,
  class: "blank_project"
}
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Your added project attachments will show up here", -1))
const _hoisted_146 = [
  _hoisted_145
]
const _hoisted_147 = { class: "footer-buttons" }

import {
  ref,
  computed,
  reactive,
  onBeforeMount,
  getCurrentInstance,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import AddressMapComponent from "@/core/components/AddressMapComponent.vue";
import BackButton from "@/core/components/common/BackButton.vue";
import EmergencyChip from "@/core/uni-components/Chips/EmergencyChip.vue";
import StandardChip from "@/core/uni-components/Chips/StandardChip.vue";
import RoutineChip from "@/core/uni-components/Chips/RoutineChip.vue";
import { quillEditor } from "vue3-quill";
import { PROJECT_ROUTE } from "../routes";
import { REQUEST_PROJECT_ESTIMATE_ROUTE } from "../routes";
import { JOBS_STORE } from "@/store/modules/jobs";
import { PROJECT, PROJECT_STORE } from "@/store/modules/project";
import tradeEstimateService from "@/core/services/trade-estimate.service";
import { ProjectJobStatusEnum } from "@/core/enums/ProjectsEnum";
import SpecialismMultiSelectModel from "../modal/SpecialismMultiSelectModel.vue";
import { USER_STORE } from "@/store/modules/user";
import CommonLoader from "@/core/components/CommonLoader.vue";
import CommonDialog from "@/core/components/CommonDialog.vue";
import moment from "moment";
import currencyFilter from "@/filters/currency.filter";
import {
  getImageStringToImageURL,
  getUserSubSkillList,
} from "@/core/utils/common";
import UserProfileLogo from "@/core/components/UserProfileLogo.vue";
import { BusinessDetailTypeEnum } from "@/core/enums/RolesEnum";
import { WORKSTATION } from "@/store/modules/workstation";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectRequestedDetailPage',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const projectData = ref(null) as any;
const internalInstance = getCurrentInstance();
const projectComments: any = ref([]);
const isEditProjectNoteSection = ref(false);
const isEditPropertiesSection = ref(false);

const isEditAttachmentsSection = ref({
  flag: false,
  id: -1,
}) as any;
const isLoadingRemoveAttachments = ref(false);
const isShowAttachmentModal = ref(false);
const isLoadingProjectNotes = ref(false);
const isShowSpecialismModal = ref(false);
const isLoadingOnCancel = ref(false);
const isCarouselDialog = ref(false);
const currentIndex = ref(0);
const isLoadingOnAttachmentCancel = ref(false);
const isLoadingUpdatePropriety = ref(false);
const projectMetaData = ref(null) as any;
const loading = ref(false);
const projectRefId = ref("") as any;
const addresses: any = ref([]);
const projectAttachments = ref([]) as any;
const loadingSelectProperty = ref(false);
const isLoadingProjectData = ref(false);
const isShowPropertyListModal = ref(false);

const selectedFile = ref([]);
const imageUrl = ref("");
const errorMessage = ref("");
const uploadedImages = ref(null) as any;
const userCategory = [
  {
    name: "Floorplan",
  },
  {
    name: "Garden",
  },
  {
    name: "Materials",
  },
  {
    name: "Maps",
  },
];
const panel = ref([]) as any;
const propertyId = ref();
const attachmentsUpdateList = ref([]) as any;
const carouselImageList = ref();
const availableCategoryList = ref();
const attachmentDataList = ref([]) as any;
const cloneAttachmentDataList = ref([]) as any;
const isLoadingUploadAttachments = ref(false);
const isNewPropertyAdded = ref(false);
const removeAttachmentsIds = ref([]) as any;
const isLoadingForSaveSpecialism = ref(false);
const selectedIndices = ref([]) as any;
const userSelectedProperties = ref([]) as any;
const deletedProject = ref([]) as any;

const projectTitle = ref("");

const isEditSpecialismSection = ref(false);
const state = reactive({
  content: "",
  _content: "",
  editorOption: {
    placeholder: "Description here",
    modules: {},
  },
  disabled: false,
});

const onClickSaveProjectNotes = async () => {
  try {
    isLoadingProjectNotes.value = true;
    await store.dispatch(`${PROJECT_STORE}/updateProject`, {
      projectId: projectData.value?.id,
      data: {
        description: state.content,
        name: projectTitle.value,
      },
    });
    displayToast("Update successfully.", "success");
  } catch {
    console.log();
  } finally {
    await setProjectData();
    isEditProjectNoteSection.value = false;
    isLoadingProjectNotes.value = false;
  }
};
const onCancelProjectNotes = () => {
  isEditProjectNoteSection.value = false;
};
const updateProjectNameNote = (project: any) => {
  projectTitle.value = project?.name;
  state.content = project?.description;
  isEditProjectNoteSection.value = true;
};
const onClickBackToSearchResults = async () => {
  await store.dispatch(
    `${PROJECT_STORE}/setProjectRedirectTabName`,
    "requested-projects"
  );
  router.push({ name: PROJECT_ROUTE });
};
const updateSpecialismSection = () => {
  isEditSpecialismSection.value = true;
};

const onClickCloseTab = () => {
  isShowSpecialismModal.value = false;
};
const onClickAddMoreSpecialism = () => {
  isShowSpecialismModal.value = true;
};
const onClickCancelSpecialismButton = async () => {
  isEditSpecialismSection.value = false;
  await setProjectData();
};
const setProjectData = async () => {
  try {
    isLoadingProjectData.value = true;
    const projectDataResponse = await store.dispatch(
      `${PROJECT_STORE}/getProjectData`,
      {
        projectRefId: projectRefId.value,
      }
    );
    projectData.value = projectDataResponse;
    if (!projectMetaData.value) {
      if (projectData.value.projectMetaData) {
        projectMetaData.value = projectData.value.projectMetaData;

        const profileImg = projectMetaData.value?.userWorkStation.profileImage;

        projectMetaData.value = {
          ...projectMetaData.value,
          userWorkStation: {
            ...projectMetaData.value?.userWorkStation,
            profileURL: await getImageStringToImageURL(profileImg),
          },
        };
      }
    }

    availableCategoryList.value = await store.dispatch(
      `${PROJECT_STORE}/getProjectCategoryList`,
      projectDataResponse?.id
    );

    store.dispatch(`${PROJECT}/projectDetails`, {
      inviteMembers: projectData.value?.invitedMembersAndRoles,
    });

    projectAttachments.value = projectDataResponse?.projectAttachments;

    selectedIndices.value = projectDataResponse?.projectProperties.map(
      (property: any) => property?.property?.id
    );
    projectDataResponse?.projectProperties.map((item: any) => {
      const existingPropertyIndex = userSelectedProperties.value.findIndex(
        (property: any) => property.id === item.property.id
      );
      if (existingPropertyIndex === -1)
        userSelectedProperties.value.push(item.property);
    });
    attachmentDataList.value =
      projectDataResponse?.projectAttachmentProperties.map(
        (propertyItems: any) => ({
          uploadedImages: {
            url: propertyItems[0]?.attachmentUrl,
            name: propertyItems[0]?.projectAttechment?.originalName,
            attachment: propertyItems[0]?.projectAttechment?.attachment,
            attachmentId: propertyItems[0]?.projectAttechment?.id,
            id: propertyItems[0]?.id,
          },
          propertyId: propertyItems.map(
            (property: any) => property.property.id
          ),
          userCategoryName: propertyItems[0]?.projectAttachmentsCategory?.value,
        })
      );
    cloneAttachmentDataList.value = JSON.parse(
      JSON.stringify(attachmentDataList.value)
    );
  } catch (error) {
    console.log();
    if (!projectData.value) router.push({ name: PROJECT_ROUTE });
  } finally {
    isLoadingProjectData.value = false;
  }
};

const specialismCategoryClass = (category: string) => {
  if (category.toLowerCase() === "krystal") {
    return "krystal";
  }
  if (category.toLowerCase() === "property") {
    return "property";
  }
  if (category.toLowerCase() === "trade") {
    return "trade";
  }
};
const redirectToRequestProjectEstimate = () => {
  router.push({
    name: REQUEST_PROJECT_ESTIMATE_ROUTE,
    params: {
      refId: projectData.value?.refId,
      estimateId: projectMetaData.value.projectEstimation?.id,
    },
  });
};
const displayToast = (message: string, type: string) => {
  if (
    internalInstance &&
    internalInstance.appContext.config.globalProperties.$notify
  ) {
    internalInstance.appContext.config.globalProperties.$notify[type]({
      message,
    });
  }
};
const getProjectData = async () => {
  try {
    loading.value = true;
    await setProjectData();

    if (projectRefId.value) {
      const addressList: any = [];
      projectData.value.projectProperties.length &&
        projectData.value.projectProperties.map((item: any) => {
          let latlang = null;
          const property = item.property;
          if (property && property.addressData) {
            const address =
              typeof property.addressData === "string"
                ? JSON.parse(property.addressData)
                : property.addressData;
            latlang = address?.latlng;
            addressList.push({
              address: property.address,
              uprn: property.uprn,
              latlang,
              id: property.id,
              postcode: property.postcode,
            });
          }
        });

      addresses.value = addressList;
    }
  } catch (error) {
    console.log("error:", error);
  } finally {
    loading.value = false;
  }
};
const onClickDeleteCategoryButton = (subCategoryId: number) => {
  projectData.value.subCategories = projectData.value.subCategories.filter(
    (subCategory: any) => {
      return subCategory.id !== subCategoryId;
    }
  );
};
const onClickSaveButtonClick = async (selectedCategory: any) => {
  try {
    isLoadingForSaveSpecialism.value = true;
    const projectSubCategories = projectData.value?.subCategories.map(
      (subCategory: any) => {
        return subCategory.id;
      }
    );

    const removedSubCategories = projectSubCategories.filter(
      (subCategoryId: number) => {
        return !selectedCategory.includes(subCategoryId);
      }
    );

    if (removedSubCategories.length) {
      projectData.value.subCategories = projectData.value.subCategories.filter(
        (subCategory: any) => {
          return !removedSubCategories.includes(subCategory.id);
        }
      );
    }

    const newAddedSubCategoriesIds = selectedCategory.filter(
      (subCategoryId: number) => {
        return !projectSubCategories.includes(subCategoryId);
      }
    );

    if (newAddedSubCategoriesIds.length) {
      const newAddedSubCategoriesData = await store.dispatch(
        `${PROJECT_STORE}/getNewAddedSubCategoryForProject`,
        {
          subCategoriesIds: newAddedSubCategoriesIds,
        }
      );

      newAddedSubCategoriesData.forEach((subCategory: any) => {
        projectData.value?.subCategories.push(subCategory);
      });
    }
  } catch (error) {
    console.log(error);
  } finally {
    isLoadingForSaveSpecialism.value = false;
    isShowSpecialismModal.value = false;
  }
};
const onClickSaveSpecialismButton = async () => {
  let selectedCategoryFinal = projectData.value?.subCategories.map(
    (subCategory: any) => {
      return subCategory.id;
    }
  );

  await store.dispatch(`${PROJECT_STORE}/updateSubSpecialismCategory`, {
    projectId: projectData.value?.id,
    data: {
      categoryData: selectedCategoryFinal,
    },
  });

  onClickCancelSpecialismButton();
};
const onClickRemoveProperty = async (ProjectDetails: any) => {
  deletedProject.value.push({
    id: ProjectDetails?.id,
    propertyId: ProjectDetails?.property?.id,
    isDeleted: true,
  });
  projectData.value.projectProperties =
    projectData.value.projectProperties.filter((property: any) => {
      return property?.id !== ProjectDetails?.id;
    });
};
const onClickTogglePropertyListModal = () => {
  isShowPropertyListModal.value = !isShowPropertyListModal.value;
};

const onClickCancelButton = async () => {
  try {
    isLoadingOnCancel.value = true;
    await setProjectData();
    isEditPropertiesSection.value = false;
  } catch (e) {
    console.log("Caught exception", e);
  } finally {
    isLoadingOnCancel.value = false;
    deletedProject.value = [];
  }
};
const updateProperties = async (propertiesData: any) => {
  try {
    isLoadingUpdatePropriety.value = true;
    if (propertiesData.length && projectData.value?.id)
      await store.dispatch(`${PROJECT_STORE}/updateProject`, {
        projectId: projectData.value?.id,
        data: { propertiesData },
      });
  } catch (error) {
    console.log("error", error);
  } finally {
    isLoadingUpdatePropriety.value = false;
  }
};
const onClickSaveButton = async () => {
  await updateProperties(deletedProject.value);
  onClickCancelButton();
  deletedProject.value = [];
};
const changePropertyId = async (value: any) => {
  if (value.length > 0) {
    try {
      loadingSelectProperty.value = true;
      let selectedProperties = await store.dispatch(
        `${PROJECT_STORE}/getProjectDataSelectedProperties`,
        {
          projectRefId: projectRefId.value,
          propertyIds: value,
        }
      );
      projectAttachments.value = selectedProperties;
    } catch (error) {
      console.log("error", error);
    } finally {
      loadingSelectProperty.value = false;
    }
  } else {
    projectAttachments.value = projectData.value?.projectAttachments;
  }
};
const updateAttachmentsSection = (index: number) => {
  panel.value.push(index);

  isEditAttachmentsSection.value.flag = true;
  isEditAttachmentsSection.value.index = index;
};
const isShowGroupCard = (index: number) => {
  return panel.value.includes(index);
};
const getFilterCategory: any = (category: any) => {
  const categoryData = Object.entries(category).map((data: any) => ({
    name: data[0],
    id: data[1][0]?.categoryId,
    attachments: data[1],
  }));
  return categoryData;
};
const getFilterImages: any = (category: any) => {
  const filterImages: any = [];
  return Object.values(category)
    .flat()
    .filter((category: any) => {
      if (!filterImages.includes(category.attachmentUrl)) {
        filterImages.push(category.attachmentUrl);
        return true;
      }
      return false;
    });
};
const onClickRemoveAttachment = (
  attachment: any,
  category: any,
  categoryName: any,
  attachmentIndex: any,
  categoryId: number
) => {
  projectAttachments.value[attachmentIndex].categories[categoryName] =
    projectAttachments.value[attachmentIndex].categories[categoryName].filter(
      (category: any) => {
        return category?.id !== attachment?.id;
      }
    );

  attachmentsUpdateList.value.push({
    id: attachment?.id,
    propertyIds: [
      {
        id: category?.id,
        propertyId: category?.propertyId,
        isDeleted: true,
      },
    ],
    attechmentCategoryId: attachment?.categoryId,
    isDeleted: false,
  });
};
const onClickOpenNewTab = (attachment: any) => {
  try {
    window.open(attachment);
  } catch (e) {
    console.log(e);
  }
};
const openCarousel = (idx: any = 0, categoryData: any) => {
  isCarouselDialog.value = true;
  carouselImageList.value = getFilterImages(categoryData);
  currentIndex.value = idx;
};
const onClickToggleAttachmentModal = () => {
  isShowAttachmentModal.value = !isShowAttachmentModal.value;
  isNewPropertyAdded.value = false;
};
const onCancelAttachments = async () => {
  try {
    isLoadingOnAttachmentCancel.value = true;
    await setProjectData();
    isEditAttachmentsSection.value.flag = false;
  } catch (e) {
    console.log("Error :", e);
  } finally {
    isLoadingOnAttachmentCancel.value = false;
  }
};
const onClickSaveButtonAttachmentsModal = async () => {
  try {
    isLoadingUploadAttachments.value = true;

    //new attachment add functionality
    const newAttachmentDataList = attachmentDataList.value.filter(
      (attachment: any) => attachment?.uploadedImages.imageData
    );
    const filterAttachmentDataList = attachmentDataList.value.filter(
      (attachment: any) => !attachment?.uploadedImages.imageData
    );
    // check if new category add then upload that

    for (const attachment of attachmentDataList.value) {
      const existCategory = availableCategoryList.value.find(
        (category: any) => category.label === attachment.userCategoryName
      );
      if (!existCategory) {
        const response = await store.dispatch(
          `${PROJECT_STORE}/attachmentCategory`,
          {
            label: attachment.userCategoryName,
            value: attachment.userCategoryName,
          }
        );
        availableCategoryList.value.push(response);
      }
    }

    let newCreatedAttachment = [];
    if (newAttachmentDataList.length) {
      const formData = new FormData();
      newAttachmentDataList.forEach((attachment: any) => {
        if (attachment.uploadedImages.imageData) {
          formData.append(`files`, attachment.uploadedImages.imageData);
        }
      });

      const uploadMultipleImage = await store.dispatch(
        `${USER_STORE}/uploadMultipleImage`,
        formData
      );

      newCreatedAttachment = uploadMultipleImage.map(
        (item: any, index: number) => ({
          publicUrl: item.publicUrl,
          attachment: item.attachment,
          originalName: item.originalName,
          propertyIds: newAttachmentDataList[index].propertyId.map(
            (id: any) => ({ propertyId: id, isDeleted: false })
          ),
          attechmentCategoryId: availableCategoryList.value.find(
            (category: any) =>
              category.label === newAttachmentDataList[index].userCategoryName
          ).id,
          isDeleted: false,
        })
      );
    }

    const finalDataAttachment: any = [];
    const projectDefaultPropertyIds = projectData.value?.projectProperties.map(
      (property: any) => property?.property?.id
    );
    cloneAttachmentDataList.value.forEach((attachment: any, index: any) => {
      let attachmentData;
      if (attachment.isDeleted) {
        attachmentData = {
          id: attachment?.uploadedImages?.attachmentId,
          attachment: attachment?.uploadedImages?.attachment,
          originalName: attachment?.uploadedImages?.name,
          attechmentCategoryId: attachment?.uploadedImages?.attachmentId,
          propertyIds: attachment.propertyId.map((id: any) => ({
            id: attachment?.uploadedImages?.id,
            propertyId: id,
            isDeleted: true,
          })),
          isDeleted: attachment.isDeleted,
        };
      } else {
        const propertyIds: any = [];
        projectDefaultPropertyIds.forEach((propertyId: number) => {
          if (
            attachment.propertyId.includes(propertyId) &&
            filterAttachmentDataList[index].propertyId.includes(propertyId)
          ) {
            propertyIds.push({
              id: attachment?.uploadedImages?.id,
              propertyId: propertyId,
              isDeleted: false,
            });
          } else if (
            !attachment.propertyId.includes(propertyId) &&
            filterAttachmentDataList[index].propertyId.includes(propertyId)
          ) {
            propertyIds.push({
              propertyId: propertyId,
              isDeleted: false,
            });
          } else if (
            attachment.propertyId.includes(propertyId) &&
            !filterAttachmentDataList[index].propertyId.includes(propertyId)
          ) {
            propertyIds.push({
              id: attachment?.uploadedImages?.id,
              propertyId: propertyId,
              isDeleted: true,
            });
          }
        });

        attachmentData = {
          id: attachment?.uploadedImages?.attachmentId,
          attachment: attachment?.uploadedImages?.attachment,
          originalName: attachment?.uploadedImages?.name,
          attechmentCategoryId: availableCategoryList.value.find(
            (category: any) =>
              category.label ===
              filterAttachmentDataList[index].userCategoryName
          ).id,
          propertyIds: propertyIds,
        };
      }
      finalDataAttachment.push(attachmentData);
    });
    await store.dispatch(`${PROJECT_STORE}/updateProject`, {
      projectId: projectData.value?.id,
      data: {
        attachments: [...newCreatedAttachment, ...finalDataAttachment],
      },
    });

    await setProjectData();

    isEditAttachmentsSection.value.flag = false;
  } catch (error) {
    console.log();
  } finally {
    isLoadingUploadAttachments.value = false;
    onClickToggleAttachmentModal();
  }
};
const onClickSaveButtonAttachments = async () => {
  try {
    isLoadingRemoveAttachments.value = true;
    await store.dispatch(`${PROJECT_STORE}/updateProject`, {
      projectId: projectData.value?.id,
      data: {
        attachments: attachmentsUpdateList.value,
      },
    });
    attachmentsUpdateList.value = null;
    await setProjectData();
    isEditAttachmentsSection.value.flag = false;
  } catch {
    console.log();
  } finally {
    isLoadingRemoveAttachments.value = false;
  }
};
const clearImageUrl = () => {
  imageUrl.value = "";
};
const onFileChange = async (event: any) => {
  const fileInput = event.target;
  errorMessage.value = "";
  if (fileInput.files && fileInput.files.length > 0) {
    Array.from(fileInput.files).forEach((file: any) => {
      if (file.type.includes("image")) {
        // Check image size limit (200MB)
        if (file.size <= 200 * 1024 * 1024) {
          imageUrl.value = URL.createObjectURL(file);
          uploadedImages.value = {
            url: imageUrl.value,
            name: file.name,
            imageData: file,
          };
        } else {
          errorMessage.value = "Image size exceeds the limit (200MB).";
          // Handle error message or display notification
        }
      } else if (file.type.includes("video")) {
        // Check video size limit (20MB)
        if (file.size <= 10 * 1024 * 1024) {
          uploadedImages.value = {
            type: "video",
            name: file.name,
            imageData: file,
          };
          // Process video file
        } else {
          errorMessage.value = "Video size exceeds the limit (20MB).";
          // Handle error message or display notification
        }
      } else {
        // Allow other file types without size validation
        imageUrl.value = URL.createObjectURL(file);
        uploadedImages.value = {
          url: imageUrl.value,
          name: file.name,
          imageData: file,
        };
      }
    });
  } else {
    console.error("Error: No file selected.");
  }
};
const addPropertyImage = () => {
  attachmentDataList.value.push({
    uploadedImages: { ...uploadedImages.value },
    propertyId: null,
    userCategoryName: null,
  });
  uploadedImages.value = null;
  isNewPropertyAdded.value = true;
  selectedFile.value = [];
  imageUrl.value = "";
};
const removeImageFromAttachments = (index: number, attachmentId: any) => {
  removeAttachmentsIds.value.push(attachmentId);
  attachmentDataList.value.splice(index, 1);
  cloneAttachmentDataList.value.forEach((attachment: any) => {
    if (attachment.uploadedImages.attachmentId === attachmentId) {
      attachment["isDeleted"] = true;
    }
  });
};
const duration = computed(() => {
  const startDate = moment(
    projectMetaData.value?.projectEstimation?.suggestedStartDate
  );
  const endDate = moment(
    projectMetaData.value?.projectEstimation?.suggestedEndDate
  );

  const totalDays = endDate.diff(startDate, "days");
  const totalWeeks = endDate.diff(startDate, "weeks");

  let result;

  if (totalDays % 7 === 0) {
    result = `${totalWeeks} week${totalWeeks !== 1 ? "s" : ""}`;
  } else {
    result = `${totalDays} day${totalDays !== 1 ? "s" : ""}`;
  }

  return result;
});
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);
const getAllSpecialism = computed(
  () => store.getters[`${USER_STORE}/getAllSpecialism`]
);
const getUserSkillList = (userSkill: any) => {
  return getUserSubSkillList(userSkill, getAllSpecialism.value);
};
const formattedCurrency = (amount: any) => {
  return currencyFilter.formatToCurrency(amount);
};
onBeforeMount(async () => {
  if (route.params && route.params.refId) {
    projectRefId.value = route.params.refId;

    await getProjectData();

    try {
      if (!getAllSpecialism.value.length) {
        await store.dispatch(
          `${USER_STORE}/setAllSpecialismsCategory`,
          activeUserWorkstation.value.id
        );
      }
    } catch (error) {
      console.log();
    }
  } else {
    router.push({ name: PROJECT_ROUTE });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, _toDisplayString(projectData.value?.type), 1)
                  ])
                ]),
                _hoisted_12
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(moment)(
                    projectMetaData.value?.projectEstimation?.suggestedStartDate
                  ).format("DD MMMM YYYY")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, _toDisplayString(projectMetaData.value?.projectEstimation?.totalPhases), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, _toDisplayString(projectMetaData.value?.projectEstimation?.totalTasks), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, _toDisplayString(duration.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, _toDisplayString(formattedCurrency(
                    projectMetaData.value?.projectEstimation?.totalEstimateCost
                  )), 1)
                  ]),
                  _hoisted_32,
                  _createVNode(_component_v_btn, {
                    class: "button button-orange",
                    onClick: redirectToRequestProjectEstimate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" verify the estimate ")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_33
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_v_btn, {
                  "prepend-icon": "mdi-chevron-left",
                  variant: "plain",
                  onClick: onClickBackToSearchResults
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Back ")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(StandardChip)
            ]),
            _createElementVNode("div", _hoisted_37, [
              (!isEditProjectNoteSection.value)
                ? (_openBlock(), _createBlock(_component_v_card, {
                    key: 0,
                    class: "project_info"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("h5", _hoisted_41, _toDisplayString(projectData.value?.name), 1),
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createVNode(_component_v_icon, { class: "pointer_events_none" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      class: "pointer_events_none",
                                      src: require('@/assets/icons/user.svg'),
                                      alt: ""
                                    }, null, 8, _hoisted_44)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_45
                              ]),
                              _createElementVNode("div", _hoisted_46, [
                                _hoisted_47,
                                _createElementVNode("span", _hoisted_48, _toDisplayString(projectData.value?.refId), 1)
                              ])
                            ])
                          ]),
                          _createVNode(_component_v_icon, {
                            class: "custom_edit",
                            icon: "mdi-pencil",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (updateProjectNameNote(projectData.value)), ["stop"]))
                          })
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _createElementVNode("p", {
                            innerHTML: projectData.value?.description
                          }, null, 8, _hoisted_51)
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_card, {
                    key: 1,
                    class: "edit_project_info"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _createVNode(_component_v_text_field, {
                          density: "compact",
                          placeholder: "enter title",
                          variant: "outlined",
                          modelValue: projectTitle.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((projectTitle).value = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _createElementVNode("div", _hoisted_56, [
                          _createVNode(_unref(quillEditor), {
                            value: state.content,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((state.content) = $event)),
                            options: state.editorOption,
                            disabled: state.disabled,
                            class: "editor_ql"
                          }, null, 8, ["value", "options", "disabled"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_v_btn, {
                          class: "button button-white",
                          onClick: onCancelProjectNotes,
                          variant: "outlined"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" cancel ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          class: "button button-orange",
                          onClick: onClickSaveProjectNotes,
                          loading: isLoadingProjectNotes.value,
                          "prepend-icon": "mdi-content-save"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" save ")
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ])
                    ]),
                    _: 1
                  }))
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                (!isEditSpecialismSection.value)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      class: "custom_edit",
                      icon: "mdi-pencil",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (updateSpecialismSection()), ["stop"]))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_61, [
                (!projectData.value?.subCategories?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, "No Specialism"))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_63, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectData.value?.subCategories, (subCategory) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "specialism-card-list__item",
                      key: subCategory.id
                    }, [
                      (isEditSpecialismSection.value)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            variant: "text",
                            "aria-label": "Delete",
                            class: "specialism-card-list__item-delete",
                            "prepend-icon": "mdi-delete",
                            onClick: ($event: any) => (onClickDeleteCategoryButton(subCategory?.id))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["specialism-card-list__item-author-header", specialismCategoryClass(subCategory?.generatedBy)])
                        }, [
                          _createElementVNode("div", _hoisted_65, [
                            (
                        specialismCategoryClass(subCategory?.generatedBy) ===
                        'krystal'
                      )
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: require('@/assets/icons/krystal.svg'),
                                  alt: "krystalImg"
                                }, null, 8, _hoisted_66))
                              : _createCommentVNode("", true),
                            (
                        specialismCategoryClass(subCategory?.generatedBy) ===
                        'property'
                      )
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: require('@/assets/icons/house.svg'),
                                  alt: "houseimage"
                                }, null, 8, _hoisted_67))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("h6", null, _toDisplayString(subCategory?.generatedBy), 1),
                          _createVNode(_component_v_icon, { icon: "mdi-information-variant-circle-outline" })
                        ], 2),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("img", {
                              src: 
                        require('@/assets/category-icons/' +
                          subCategory?.category?.iconName +
                          '.svg')
                      ,
                              alt: "Image"
                            }, null, 8, _hoisted_70)
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("h5", null, _toDisplayString(subCategory?.label), 1),
                            _createElementVNode("p", null, _toDisplayString(subCategory?.category?.poLabel), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              (isEditSpecialismSection.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    _createVNode(_component_v_btn, {
                      class: "button button-purple-border",
                      variant: "text",
                      onClick: onClickAddMoreSpecialism
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Add more Specialism ")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_73, [
                      _createVNode(_component_v_btn, {
                        class: "button button-white",
                        onClick: onClickCancelSpecialismButton,
                        variant: "outlined"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" cancel ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        class: "button button-orange",
                        loading: isLoadingProjectData.value,
                        onClick: onClickSaveSpecialismButton
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" save ")
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_74, [
              _hoisted_75,
              _createElementVNode("div", _hoisted_76, [
                _createVNode(_component_v_card, { class: "client_card" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        (projectMetaData.value.userWorkStation?.profileURL)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              alt: "Profile Image",
                              src: projectMetaData.value.userWorkStation?.profileURL
                            }, null, 8, _hoisted_79))
                          : (_openBlock(), _createBlock(UserProfileLogo, {
                              key: 1,
                              userName: `${projectMetaData.value.userWorkStation?.user?.firstName} 
                          ${projectMetaData.value.userWorkStation?.user?.lastName}`
                            }, null, 8, ["userName"]))
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("h4", null, _toDisplayString(projectMetaData.value.userWorkStation?.user?.firstName) + " " + _toDisplayString(projectMetaData.value.userWorkStation?.user?.lastName), 1),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("span", null, _toDisplayString(_unref(BusinessDetailTypeEnum).SOLETRADER ===
                      projectMetaData.value.userWorkStation?.user?.userBusinessDetails
                        ?.type
                        ? "Solo Trader"
                        : "Limited Company"), 1),
                          _createTextVNode(" | "),
                          _createElementVNode("p", null, _toDisplayString(projectMetaData.value.userWorkStation?.user?.postcode || "N/A"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getUserSkillList(
                  projectMetaData.value?.userWorkStation?.user?.userSkills
                ).slice(0, 1), (skill) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "custom_tags",
                          key: skill.id
                        }, [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              (skill?.iconName)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: 
                      require('@/assets/category-icons/' +
                        skill?.iconName +
                        '.svg')
                    
                                  }, null, 8, _hoisted_83))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("span", null, _toDisplayString(skill?.label), 1)
                        ]))
                      }), 128)),
                      (
                  getUserSkillList(
                    projectMetaData.value?.userWorkStation?.user?.userSkills
                  ).length > 1
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                            _createElementVNode("span", null, " +" + _toDisplayString(getUserSkillList(
                      projectMetaData.value?.userWorkStation?.user?.userSkills
                    ).length - 1) + " More ", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (projectMetaData.value.userWorkStation?.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                            _createElementVNode("p", _hoisted_86, _toDisplayString(projectMetaData.value.userWorkStation?.description), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("h4", _hoisted_90, [
                    _createTextVNode(" Properties "),
                    _createElementVNode("span", _hoisted_91, _toDisplayString(projectData.value?.projectProperties?.length), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("div", _hoisted_93, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectData.value?.projectProperties, (property, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "properties_wrapper__info",
                      key: property?.id
                    }, [
                      (isEditPropertiesSection.value)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            class: "delete__icon",
                            icon: "mdi-delete",
                            onClick: _withModifiers(($event: any) => (onClickRemoveProperty(property)), ["stop"])
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("div", _hoisted_95, [
                          _createVNode(_component_v_icon, {
                            icon: "mdi mdi-map-marker",
                            class: "pointer_events_none"
                          }),
                          _createTextVNode(" " + _toDisplayString(property?.property?.postcode), 1)
                        ]),
                        _createElementVNode("div", _hoisted_96, [
                          _createVNode(_component_v_icon, { class: "pointer_events_none" }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                alt: "house-icon",
                                src: require('@/assets/icons/house.svg')
                              }, null, 8, _hoisted_97)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("h6", _hoisted_98, _toDisplayString(property?.property?.address), 1)
                        ]),
                        _createElementVNode("div", _hoisted_99, [
                          _createElementVNode("div", _hoisted_100, _toDisplayString(property?.property?.propertyType || "NA"), 1),
                          _hoisted_101,
                          _createElementVNode("div", _hoisted_102, [
                            _createElementVNode("span", _hoisted_103, _toDisplayString(property?.property?.beds || "NA"), 1),
                            _createTextVNode(" bedroom ")
                          ]),
                          _hoisted_104,
                          _createElementVNode("div", _hoisted_105, [
                            _createElementVNode("span", _hoisted_106, _toDisplayString(property?.property?.propertySize || "NA"), 1),
                            _createTextVNode(" sqm ")
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_107, [
                          _createVNode(_component_v_icon, {
                            icon: "mdi mdi-account-circle",
                            class: "pointer_events_none"
                          }),
                          _createTextVNode("Commercial ")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_108, [
                        _hoisted_109,
                        (!isEditPropertiesSection.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, _toDisplayString(index + 1), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_111, [
                  (addresses.value && addresses.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                        _createVNode(AddressMapComponent, {
                          class: "pointer_events_none",
                          latlng: [53.5809811, -0.6393335],
                          addresses: addresses.value
                        }, null, 8, ["addresses"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (isEditPropertiesSection.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                    _createVNode(_component_v_btn, {
                      class: "button button-purple-border",
                      onClick: onClickTogglePropertyListModal,
                      variant: "text"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Add more Property ")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_114, [
                      _createVNode(_component_v_btn, {
                        class: "button button-white",
                        loading: isLoadingOnCancel.value,
                        onClick: onClickCancelButton,
                        variant: "outlined"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" cancel ")
                        ]),
                        _: 1
                      }, 8, ["loading"]),
                      _createVNode(_component_v_btn, {
                        class: "button button-orange",
                        loading: isLoadingProjectData.value,
                        onClick: onClickSaveButton
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" save ")
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!loadingSelectProperty.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                  _createElementVNode("div", _hoisted_116, [
                    _hoisted_117,
                    _createVNode(_component_v_select, {
                      modelValue: propertyId.value,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((propertyId).value = $event)),
                        changePropertyId
                      ],
                      label: "Select property",
                      items: projectAttachments.value,
                      "item-title": "address",
                      "item-value": "propertyId",
                      multiple: "",
                      variant: "outlined",
                      density: "compact",
                      class: "select_prop_dropdown",
                      "menu-props": { contentClass: 'custom__text__selector' }
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _createVNode(_component_v_expansion_panels, {
                    modelValue: panel.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((panel).value = $event)),
                    multiple: "",
                    class: "accordion__wrapper"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectAttachments.value, (property, index) => {
                        return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panel_title, null, {
                              actions: _withCtx(({ expanded }) => [
                                (expanded && !isEditAttachmentsSection.value.flag)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      class: "custom_edit",
                                      icon: "mdi-pencil",
                                      onClick: ($event: any) => (updateAttachmentsSection(index))
                                    }, null, 8, ["onClick"]))
                                  : (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 1,
                                      icon: "mdi-chevron-down",
                                      class: "bottom__chevron"
                                    }))
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { class: "house__icon" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: require('@/assets/icons/house.svg'),
                                      alt: ""
                                    }, null, 8, _hoisted_118)
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("h6", null, _toDisplayString(property?.address), 1)
                              ]),
                              _: 2
                            }, 1024),
                            (isShowGroupCard(index))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                  _createElementVNode("div", _hoisted_120, [
                                    _createVNode(_component_v_expansion_panel_text, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFilterCategory(property.categories), (category) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "accordion_inner_title",
                                            key: category.id
                                          }, [
                                            _createElementVNode("h3", null, _toDisplayString(category?.name), 1),
                                            _createElementVNode("div", _hoisted_121, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.attachments, (attachment) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  class: "doc_main__list",
                                                  key: attachment.id
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: "property__img__name",
                                                    onClick: _withModifiers(($event: any) => (
                            onClickOpenNewTab(attachment.attachmentUrl)
                          ), ["stop"])
                                                  }, [
                                                    _createVNode(_component_v_icon, { icon: "mdi mdi-image-outline" }),
                                                    _createElementVNode("span", _hoisted_123, _toDisplayString(attachment?.originalName), 1)
                                                  ], 8, _hoisted_122),
                                                  (
                            isEditAttachmentsSection.value.flag &&
                            isEditAttachmentsSection.value.index === index
                          )
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        onClick: ($event: any) => (
                            onClickRemoveAttachment(
                              attachment,
                              property,
                              category?.name,
                              index,
                              category?.id
                            )
                          )
                                                      }, [
                                                        _createVNode(_component_v_icon, {
                                                          icon: "mdi-close",
                                                          class: "pointer_events_none"
                                                        })
                                                      ], 8, _hoisted_124))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ])
                                          ]))
                                        }), 128)),
                                        (!isEditAttachmentsSection.value.flag)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFilterImages(
                        property.categories
                      ), (attachment, idx) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: attachment.id,
                                                  class: "property__item__images"
                                                }, [
                                                  _createElementVNode("img", {
                                                    src: attachment?.attachmentUrl,
                                                    onClick: ($event: any) => (openCarousel(idx, property.categories))
                                                  }, null, 8, _hoisted_126)
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
                      isEditAttachmentsSection.value.flag &&
                      isEditAttachmentsSection.value.index === index
                    )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                              _createVNode(_component_v_btn, {
                                                class: "button button-purple-border",
                                                onClick: onClickToggleAttachmentModal
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Upload More ")
                                                ]),
                                                _: 1
                                              }),
                                              _createElementVNode("div", _hoisted_128, [
                                                _createVNode(_component_v_btn, {
                                                  class: "button button-white",
                                                  variant: "outlined",
                                                  loading: isLoadingOnAttachmentCancel.value,
                                                  onClick: onCancelAttachments
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" cancel ")
                                                  ]),
                                                  _: 1
                                                }, 8, ["loading"]),
                                                _createVNode(_component_v_btn, {
                                                  class: "button button-orange",
                                                  size: "large",
                                                  block: "",
                                                  loading: isLoadingRemoveAttachments.value,
                                                  onClick: onClickSaveButtonAttachments
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" save ")
                                                  ]),
                                                  _: 1
                                                }, 8, ["loading"])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(CommonLoader, { loading: loadingSelectProperty.value }, null, 8, ["loading"])
          ]),
          _createVNode(CommonDialog, {
            modelValue: isShowAttachmentModal.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isShowAttachmentModal).value = $event)),
            isShowHeader: false,
            isShowBackButton: false,
            width: "832px",
            "max-width": "100%",
            persistent: "",
            className: ['property__upload__modal ']
          }, {
            body: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: "mdi-close",
                class: "close__icon",
                onClick: onClickToggleAttachmentModal
              }),
              _createElementVNode("div", _hoisted_129, [
                _createElementVNode("div", _hoisted_130, [
                  _hoisted_131,
                  _createElementVNode("div", _hoisted_132, [
                    _createElementVNode("div", _hoisted_133, [
                      _createVNode(_component_v_file_input, {
                        class: _normalizeClass(["upload_file", { 'added-img': imageUrl.value }]),
                        label: "Upload",
                        "append-inner-icon": "mdi-image-plus",
                        accept: "image/png, image/jpeg, image/jpg",
                        variant: "solo-filled",
                        modelValue: selectedFile.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedFile).value = $event)),
                        onChange: onFileChange,
                        "onClick:clear": clearImageUrl,
                        multiple: ""
                      }, null, 8, ["modelValue", "class"]),
                      _createVNode(_component_v_img, {
                        class: "uploaded-img",
                        width: 200,
                        "aspect-ratio": "16/9",
                        cover: "",
                        src: imageUrl.value
                      }, null, 8, ["src"]),
                      _createVNode(_component_v_icon, { icon: "mdi mdi-file-image-box" }),
                      (errorMessage.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_134, _toDisplayString(errorMessage.value), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_135
                  ]),
                  _createElementVNode("div", _hoisted_136, [
                    _createVNode(_component_v_btn, {
                      "aria-label": "Refresh",
                      class: "button button-orange",
                      onClick: addPropertyImage,
                      disabled: !uploadedImages.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(attachmentDataList.value.length ? "ADD ANOTHER" : "add"), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_137, [
                  (attachmentDataList.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                        _hoisted_139,
                        _createElementVNode("div", _hoisted_140, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachmentDataList.value, (attachment, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "show_uploaded_details",
                              key: index
                            }, [
                              _createVNode(_component_v_img, {
                                class: "uploaded-img",
                                width: 156,
                                height: 88,
                                "aspect-ratio": "16/9",
                                cover: "",
                                src: attachment?.uploadedImages?.url
                              }, null, 8, ["src"]),
                              _createElementVNode("div", _hoisted_141, [
                                _createElementVNode("h5", null, _toDisplayString(attachment?.uploadedImages?.name), 1),
                                _createVNode(_component_v_btn, {
                                  onClick: ($event: any) => (
                        removeImageFromAttachments(
                          index,
                          attachment?.uploadedImages?.attachmentId
                        )
                      ),
                                  variant: "text",
                                  class: "button button-lightGray"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_142
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _createElementVNode("div", _hoisted_143, [
                                _createVNode(_component_v_select, {
                                  modelValue: attachment.propertyId,
                                  "onUpdate:modelValue": ($event: any) => ((attachment.propertyId) = $event),
                                  label: "Select property",
                                  items: userSelectedProperties.value,
                                  "item-title": "address",
                                  "item-value": "id",
                                  multiple: "",
                                  variant: "outlined",
                                  density: "compact",
                                  class: "selectprop_dropdown",
                                  "menu-props": { contentClass: 'text__selector' }
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]),
                                _createVNode(_component_v_text_field, {
                                  density: "compact",
                                  placeholder: "E.g. Public liability",
                                  variant: "outlined",
                                  modelValue: attachment.userCategoryName,
                                  "onUpdate:modelValue": ($event: any) => ((attachment.userCategoryName) = $event),
                                  class: "v-text-custom selectprop_dropdown",
                                  "menu-props": { contentClass: 'text__selector' }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: "mdi-chevron-down",
                                      id: `menu-activator-${index}`,
                                      class: "cursor-pointer"
                                    }, null, 8, ["id"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createVNode(_component_v_menu, {
                                transition: "slide-y-reverse-transition",
                                class: "slider-menu-active pro_review_drop",
                                activator: `#menu-activator-${index}`,
                                active: true,
                                "menu-props": { contentClass: 'pro_review_drop' }
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, {
                                    class: "dropdown_selector",
                                    "menu-props": { contentClass: 'text__selector' }
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(userCategory, (item, index) => {
                                        return _createVNode(_component_v_list_item, { key: index }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, {
                                              class: "cursor-pointer",
                                              onClick: ($event: any) => (attachment.userCategoryName = item.name)
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.name), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      }), 64))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["activator"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_144, _hoisted_146))
                ])
              ]),
              _createElementVNode("div", _hoisted_147, [
                _createVNode(_component_v_btn, {
                  class: "button button-purple-border",
                  onClick: onClickToggleAttachmentModal,
                  variant: "outlined"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" cancel ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  class: "button button-orange",
                  loading: isLoadingUploadAttachments.value,
                  onClick: onClickSaveButtonAttachmentsModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" save ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_dialog, {
            modelValue: isCarouselDialog.value,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((isCarouselDialog).value = $event)),
            height: "auto",
            "max-width": "600",
            class: "project__carousal__modal",
            "show-arrows": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                actions: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    icon: "mdi-close",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (isCarouselDialog.value = false)),
                    class: "d-flex"
                  }),
                  _createVNode(_component_v_carousel, {
                    "hide-delimiter-background": "",
                    "show-arrows": "hover",
                    modelValue: currentIndex.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((currentIndex).value = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carouselImageList.value, (attachment) => {
                        return (_openBlock(), _createBlock(_component_v_carousel_item, {
                          key: attachment.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_img, {
                              cover: "",
                              src: attachment?.attachmentUrl,
                              height: "100%",
                              width: "100%"
                            }, null, 8, ["src"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (isShowSpecialismModal.value)
            ? (_openBlock(), _createBlock(SpecialismMultiSelectModel, {
                key: 0,
                isHistorical: false,
                projectId: projectData.value.id,
                selectedSpecialism: projectData.value?.subCategories,
                isLoading: isLoadingForSaveSpecialism.value,
                onOnClickCloseTab: onClickCloseTab,
                onOnClickSaveButtonClick: onClickSaveButtonClick
              }, null, 8, ["projectId", "selectedSpecialism", "isLoading"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(CommonLoader, { loading: loading.value }, null, 8, ["loading"])
  ], 64))
}
}

})